module.exports = __webpack_public_path__ + "4d188cb.woff2";